import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getEstimationCategoryMaterialList } from "../../../services/Settings/dropdown"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const EstimationMaterialCategory = ({
  control,
  name,
  onSelectChange,
  target,
  placeholder,
  classCode,
  disabled,
  type,
  dropView
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [fetchResponse, setFetchResponse] = useState([])
  const loadOptions = async () => {
    setIsLoading(true)
    const data = await getEstimationCategoryMaterialList(classCode?.id, type)
    if (!data?.data) {
      setFetchResponse([])
      setIsLoading(false)
      return
    }
    const response = data?.data?.map(dta => {
      return {
        label:
          dta?.category_code &&
          ucfirst(`${dta.category_code}-${dta?.description}`),
        value: dta.id,
        ...dta,
      }
    })

    setFetchResponse(response)
    setIsLoading(false)
  }
  useEffect(() => {
    if (classCode?.value) {
      loadOptions()
    }
  }, [classCode?.value])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        defaultValue={null} // Ensure a default value is set
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Select
              options={fetchResponse}
              // placeholder={placeholder ? placeholder : "Select"}
              placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
              isLoading={isLoading}
              inputRef={ref}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              isDisabled={disabled ? true : false}
              value={
                value
                  ? value
                  : fetchResponse.find(option => option.value === value)
              } // Ensure value is stable
              classNamePrefix="react-select"
              className="elevate-dropdown"
              // menuPortalTarget={document.querySelector(
              //   target ? target : ".modal"
              // )}
              menuPortalTarget={document.body} // Ensure the dropdown renders correctly within the modal
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              menuPlacement={dropView ? "top" : "bottom"}
            />
          )
        }}
      />
    </div>
  )
}

export default EstimationMaterialCategory
